/**
 * BatchGeoContextMenu is a module to create a custom right click menu for the
 * BatchGeo mapping service. It will allow you to create separate instances of
 * the menus as well, so you can have different context options when different
 * trigger elements are specified.
 */
window.BatchGeoContextMenu = (function () {
  /**
   * - triggerEl: Not Required. Selector of the element you would like to trigger
   *   the context menu. It is not required because if you do not specify a
   *   trigger element then the trigger element will be the document body by default.
   *
   * - menuItems: Required. An array of menu item option objects to populate the
   *   context menu. If this array is not passed or an empty array is passed the
   *   menu will _not_ be created.
   *
   *   Example menu item object:
   *
   *   - label: title of the menu item
   *
   *   - selected: (optional) if the menu item is toggle-able, such as an
   *     alternate view that you can enable or disable, then the `selected`
   *     prop will tell the contextmenu whether this option is enabled or
   *     disabled on creation. If themenu item is _not_ toggle-able, simply
   *     leave this prop out.
   *
   *   - disabled: condition to determine whether or not the menu option is
   *     disabled. This can be a boolean if the menu item is always/never
   *     disabled, or it can be a function, if the condition to determine disabled
   *     status can change.
   *
   *   - visibility (optional): An array of booleans that if not ALL true will
   *     hide the option from the menu.
   *
   *   - callback: the function you would like to be executed when this item is clicked
   *
   *   {
   *      label: 'Menu Item',
   *      selected: 1 > 0,
   *      disabled: true,
   *      callback: function () { alert('I was toggled!'); }
   *   }
   *
   * Example initialization:
   *
   * window.contextMenu = BatchGeoContextMenu({
   *   triggerEl: '#triggerEl',
   *   menuItems: [
   *     {
   *       label: "Reset",
   *       disabled: function () {
   *         return 1 > 0;
   *       },
   *       callback: function () {
   *         alert('Reset triggered!');
   *       }
   *     },
   *     {
   *       label: "Alt View",
   *       selected: 1 > 0,
   *       visibility: [isProMap, isMobile], // If is a pro map AND is mobile
   *       callback: function () {
   *         alert('View toggled!')
   *       }
   *     }
   *   ]
   * });
   * window.contextMenu.init();
   */
  return function ContextMenuInstance(options) {
    // if no menuitems then there's no menu to build
    if (!options.menuItems || !options.menuItems.length) return;

    var $body = $("body");
    var menuElement = undefined;
    var overlayElement = undefined;
    var menuButton = undefined;
    var isRenderSubMenuToLeft = false;
    var subMenus = [];
    var menuStatus = false; // hidden by default
    var visibleMenuItems = []; // By default, no items are visible

    // if no trigger element is specified then default to body
    if (!options.triggerEl) options.triggerEl = $body;
    if (!options.renderControl) options.renderControl = false;

    var _privateAPI = {
      /**
       * Adds eventlisteners to menus li's to show the submenu
       */
      setupSubMenus() {
        const $topLevelMenuItems = $(menuElement).find("li");
        $topLevelMenuItems.each(function () {
          let $submenu = $(this).find("div.context-menu");
          if ($submenu.length) {
            if ($submenu.length > 1) {
              $submenu = $(this).find($submenu[0]);
            }
            $(this).on("mouseenter", () => {
              // Get the bounding rectangle of the parent li element
              const parentRect = this.getBoundingClientRect();
              // Set the submenu position to the right of the parent li element
              const subMenuCss = {
                top: `${parentRect.bottom - parentRect.top - parentRect.height}px`,
                // left: `${parentRect.right - parentRect.left}px`,
                display: "block",
              };

              if (!isRenderSubMenuToLeft) {
                subMenuCss.left = `${parentRect.right - parentRect.left}px`;
              } else {
                subMenuCss.left = `${0 - $submenu.width()}px`;
              }

              $submenu.css(subMenuCss);
              $submenu.addClass("show");
            });
            $(this).on("mouseleave", () => {
              $submenu.css({
                display: "none",
              });
              $submenu.removeClass("show");
            });
          }
        });
        $(this.parentElement).append(this.menu);
      },

      /**
       * createMenu: takes the `menuItems` array passed in with `options` and
       * creates the context menu element. Does not add any event listeners.
       */
      createMenu: function () {
        var self = this;
        // Creates new menu elements
        menuElement = $('<div class="context-menu">');

        var list = $("<ul>");

        if (options.isSubMenu) {
          list.addClass("sub-menu-list");
        }

        if (options.isSubMenu && options.menuItems.length > 4) {
          list.addClass("sub-menu-x-offset");
        }
        // Get only items that pass the visibility function OR if there was no
        // visibility function given we assume we should always show the option
        visibleMenuItems = options.menuItems.filter(function (menuItem) {
          return (
            menuItem.visibility === undefined ||
            menuItem.visibility.indexOf(false) === -1
          );
        });

        // We only append visible items
        visibleMenuItems.forEach(function (menuItem) {
          const newMenuItem = self.createMenuItem(menuItem);
          list.append(newMenuItem);
          if (menuItem.subMenu && menuItem.subMenu.length) {
            // instantiate new context menu based on current one
            const subContextMenu = window.BatchGeoContextMenu({
              triggerEl: newMenuItem,
              renderControl: false,
              menuItems: menuItem.subMenu,
              isSubMenu: true,
            });
            subMenus.push(subContextMenu);
            subContextMenu.init();
            newMenuItem.append(subContextMenu.getMenuElement());
          }
        });

        menuElement.append(list);
        $body.append(menuElement);

        // Creates the overlay that darkens the background on mobile menus
        overlayElement = $('<div class="context-menu-overlay">');
        $body.append(overlayElement);

        // If the mobile menu is used we add a hash to the URL so that we can
        // listen for hash change which would mean adding or removing it.
        // Removing it means the user hit "back" which is a common way to hide
        // menus on many mobile devices so if it's removed we hide the menu.
        $(window).on("hashchange", function () {
          if (window.location.hash.indexOf("contextmenu") == -1) {
            _privateAPI.hideMenu();
          }
        });

        // menu and overlay are hidden initially
        this.hideMenu();
      },

      renderMenuControl: function (handler) {
        menuButton = $("<a />", {
          class: "context-menu-button",
          click: handler,
        });

        $(options.triggerEl).append(menuButton);
      },

      /**
       * createMenuItem: Takes the individual menu item object and creates an li
       * with the relevant label and classes. This also adds a listener to each
       * menu list item to execute the associated callback on mousedown.
       */
      createMenuItem: function (item) {
        var self = this;

        // item.elem = $('<li>').html(item.label);
        var $listItem = $("<li>", {
          class: "list-item-" + item.icon,
        });

        if (item.subMenu && item.subMenu.length) {
          $listItem.addClass("parent");
        }

        // Removing this impacts the height of the elements.
        if (!options.isSubMenu) {
          var $img = $("<span />", {
            class: "context-menu-item-icon " + item.icon,
            title: item.label,
            valign: "middle",
          });
        }

        var $selectSpan = $("<span />", {
          class: "context-menu-item-select",
          valign: "middle",
        });

        const isItemLabelTooLong = item.label.length > 35;
        if (options.isSubMenu && !item.subMenu && isItemLabelTooLong) {
          $listItem.attr("title", item.label);
        }
        const itemLabel = isItemLabelTooLong
          ? `${item.label.substring(0, 25).trim()}...`
          : item.label;
        if (!options.isSubMenu) {
          $listItem.append($img).append(itemLabel).append($selectSpan);
        } else {
          $listItem.append(itemLabel).append($selectSpan);
        }

        item.elem = $listItem;
        item.selectSpan = $selectSpan;

        // in case disabled function is not passed or a boolean is passed.
        var disabledValue = item.disabled;
        if (typeof disabledValue !== "function") {
          item.disabled = function () {
            return !!disabledValue;
          };
        }

        // if no selected prop at all always return false
        if (!item.selected) {
          item.noToggle = true;
          item.selected = function () {
            return false;
          };
        } else {
          var selectedValue = item.selected;
          if (typeof selectedValue !== "function") {
            item.selected = function () {
              return !!selectedValue;
            };
          }
        }

        item.elem.on("mousedown", function (e) {
          e.stopPropagation();
          self.hideMenu();
          if (!item.disabled()) {
            if (!item.noToggle) {
              // only toggle class if it is an item that can be toggled
              $(this).toggleClass("selected");
              item.selectSpan.toggleClass("selected");
            }
            // This is in a timeout because otherwise the callback
            // is called while the menu is trying to be hidden. This
            // prevents the menu from hiding because it "chokes" on
            // high CPU tasks (such as showing or hiding lots of
            // items). Timeout lets the DOM update first.
            $("body").addClass("waiting");
            setTimeout(() => {
              item.callback();
              $("body").removeClass("waiting");
            }, 0);
          }
        });

        // if selected or disabled by default add class during creation
        if (item.selected()) item.selectSpan.addClass("selected");
        if (item.disabled()) item.elem.addClass("disabled");

        return item.elem;
      },

      /**
       * Runs through each given menu item and runs the `disabled()` function.
       * If it returns true it adds the disabled class and false removes it.
       *
       * @return {undefined}
       */
      updateMenuItems: function () {
        visibleMenuItems.forEach(function (item) {
          if (item.disabled()) {
            $(item.elem).addClass("disabled");
          } else {
            $(item.elem).removeClass("disabled");
          }

          if (item.selected()) {
            $(item.selectSpan).addClass("selected");
          } else {
            $(item.selectSpan).removeClass("selected");
          }
        });
        if (subMenus.length)
          subMenus.forEach((subMenu) => subMenu.updateMenuItems());
      },

      /**
       * Shows the context menu as a "mobile" menu which is not based on mouse
       * coords, but instead always positioned to the bottom of the screen and
       * 100% width. It also triggers the overlay that darkens the background.
       *
       * @return {undefined}
       */
      showMobileMenu: function () {
        menuStatus = true;
        this.updateMenuItems();
        overlayElement.addClass("context-menu-overlay-show");
        menuElement.addClass("mobile-menu").css({
          // remove the -9999px top because it will screw up bottom positioning
          top: "auto",
          left: "0px",
        });
        window.location.hash = "contextmenu";
      },

      /**
       * showMenu: determines the proper coordinates to set the menu within the
       * viewport and sets the left/top css props to bring the element to those
       * coordinates and into view.
       */
      showMenu: function (x, y, fixed) {
        menuStatus = true; // set visibility on

        // If the non-mobile menu is triggered we need to reset bottom to auto
        // we set it to -100% in the CSS for animations for mobile menus
        menuElement.css({ transition: "none", bottom: "auto" });
        this.updateMenuItems();

        var edgeBuffer = 15;
        // Constrain to viewport
        var win = $(window);

        var x1 = x + menuElement.outerWidth() + edgeBuffer;
        var y1 = y + menuElement.outerHeight() + edgeBuffer;
        var x2 = win.scrollLeft() + win.width();
        var y2 = win.scrollTop() + win.height();
        var dx = x1 - x2;
        var dy = y1 - y2;
        if (dx > 0) x -= dx;
        if (dy > 0) y -= dy;

        // toggle nested menu
        if (x > win.width() / 2 - menuElement.width() / 2) {
          _privateAPI.toggleRenderSubMenuToLeft(true);
        } else {
          _privateAPI.toggleRenderSubMenuToLeft(false);
        }

        // Set fixed x/y based on viewport
        var menuHeight = menuElement.outerHeight();
        var buttonPosition = options.renderControl
          ? menuButton[0].offsetTop
          : 0;
        var fixedY = buttonPosition - menuHeight + 50;
        var fixedX = x;

        // If the menu starts to overlap the map button toolbar, anchor position to the right-bottom of button
        if (buttonPosition - 125 < menuHeight) {
          fixedX = x + 70;
          fixedY =
            buttonPosition < menuHeight
              ? buttonPosition - menuHeight / 2 + 70
              : fixedY + 60;
        }

        // If context menu button click - Position fixed
        // Else - Position top left corner of menu at the mouse point
        if (fixed) {
          menuElement.css({
            left: fixedX + "px",
            top: fixedY + "px",
          });
        } else {
          menuElement.css({
            left: x + "px",
            top: y + "px",
          });
        }
      },

      /**
       * hideMenu: hides the context menu element by hiding it far outside the
       * viewport.
       */
      hideMenu: function () {
        menuStatus = false; // set visibility off

        // This is janky and might need to be refactored
        $(".context-menu-button").removeClass("active");

        // Position menu outside the viewport
        menuElement.removeClass("mobile-menu").css({
          left: "-9999px",
          top: "-9999px",
        });

        overlayElement.removeClass("context-menu-overlay-show");

        // Scrub the URL of our hash change if we added it
        if (window.location.hash.indexOf("#contextmenu") > -1) {
          history.pushState(
            "",
            document.title,
            window.location.href.split("#")[0],
          );
        }

        if (
          options.isSubMenu &&
          window.batchGeoMapContextMenu &&
          window.batchGeoMapContextMenu.isVisible &&
          window.batchGeoMapContextMenu.isVisible()
        ) {
          window.batchGeoMapContextMenu.hideMenu();
        }

        // TODO: Deprecate
        // There is no 'CONTEXT_MENU_CLOSE' type defined
        // in context-menu reducers.
        BatchGeoStore.dispatch({ type: "CONTEXT_MENU_CLOSE" });
      },

      toggleRenderSubMenuToLeft: function (boolean) {
        isRenderSubMenuToLeft = boolean;

        if (subMenus.length) {
          subMenus.forEach((subMenu) =>
            subMenu.toggleRenderSubMenuToLeft(boolean),
          );
        }
      },
    };

    // Public API
    return {
      /**
       *
       * @returns {HTML} - Menu Element
       */
      getMenuElement: function () {
        return menuElement;
      },

      /**
       * Enables recursive calling of updateMenuItems on nested menus
       */
      updateMenuItems: _privateAPI.updateMenuItems,

      /**
       * Enables recursive calling of toggleRenderSubMenuToLeft
       */
      toggleRenderSubMenuToLeft: _privateAPI.toggleRenderSubMenuToLeft,

      /**
       * Enables submenus to hide the parent menu
       */
      hideMenu: _privateAPI.hideMenu,

      /**
       *
       * @returns {Boolean} wether or not the menu is currently visible in the dom
       */
      isVisible: function () {
        return menuStatus;
      },

      /**
       * init: builds the menu element, adds the right click listener to show
       * the menu on right click, and adds the body listener to hide the menu
       * on mousedown.
       */
      init: function () {
        if ($(options.triggerEl).length === 0) return;

        // create the menu element based on the menu items passed in options
        _privateAPI.createMenu();
        _privateAPI.setupSubMenus();

        // if specified, render a visible control for this context menu
        if (options.renderControl)
          _privateAPI.renderMenuControl(this.clickMenu);

        // contextmenu is not reliable enough so if the custom context menu is
        // being activated then we block the context menu event from doing
        // anything. IE9 requires this event to happen on the body so in our
        // handler we check if the element that triggered the context menu is a
        // child of the triggerEl or it is the triggerEl. If so cancel the menu.
        this._contextMenuHandler = function (e) {
          if (
            $(options.triggerEl).find(e.target).length ||
            $(options.triggerEl)[0] === e.target ||
            // This particular line is odd. It only happens on Win10 on
            // Chrome. On there the e.target is the `<ul>` element inside
            // the menuElement. Before that this wouldn't return false
            // causing the native context menu to pop up as well
            menuElement.find(e.target).length
          ) {
            return false;
          }
        };

        $(document.body).on(
          "contextmenu.batchgeocontextmenu",
          this._contextMenuHandler,
        );

        // and then we use mouseup with button detection to get the right click event.
        $(options.triggerEl).on("mouseup.batchgeocontextmenu", function (e) {
          if (e.button == 2) {
            // 2 = right click button
            //save which row right clicked to open menu
            BatchGeoStore.dispatch({
              type: "CONTEXT_MENU_OPEN",
              clickedRow: $(e.target).parent().data("id"),
            });
            _privateAPI.showMenu(e.pageX, e.pageY);

            // mousedown handler to hide the menu if it is visible
            var bodyMousedownHandler = function () {
              if (menuStatus) {
                _privateAPI.hideMenu();
                $body.off("mousedown", bodyMousedownHandler);
              }
            };

            $body.on("mousedown", bodyMousedownHandler);
          }
        });

        // If the user mouse's down on the overlay hide the menu
        overlayElement.on("mousedown", function () {
          _privateAPI.hideMenu();
        });

        // Handle the long press context menu triggers for mobile
        // longpressTimer tracks the timeout that is created on touchstart that,
        // if not cleared, will trigger showing the mobile context menu
        var longpressTimer;
        // longpressMovement tracks the coords of the touchstart event that
        // checks the distance the user moved during touchmove
        var longpressMovement;
        $(options.triggerEl)
          .on("touchstart.batchgeocontextmenu", function (e) {
            // If they have two fingers touching ignore. They're probably zooming
            if (e.originalEvent.touches.length > 1) return;

            // touch events keep an array of each finger that is pressed but since
            // we only want the first finger we grab the first touch in the array
            e = e.originalEvent.touches[0];
            longpressMovement = { pageX: e.pageX, pageY: e.pageY };
            // Queue timer and get ready to show the mobile menu if not cleared
            longpressTimer = window.setTimeout(function () {
              //save which row opened context menu
              BatchGeoStore.dispatch({
                type: "CONTEXT_MENU_OPEN",
                clickedRow: $(e.target).parent().data("id"),
              });
              _privateAPI.showMobileMenu();
            }, 750);
          })
          .on("touchmove.batchgeocontextmenu", function (e) {
            if (!longpressMovement) return;
            e = e.originalEvent.touches[0];
            // If this touch move event is more than 10px on either the X or Y
            // axis from the starting location set in touchstart we can consider
            // this a true move event so we clear the timer because they're
            // scrolling, panning, or something. We track this because it's very
            // easy to move your finger a few pixels while holding down.
            if (
              Math.abs(e.pageX - longpressMovement.pageX) > 10 ||
              Math.abs(e.pageY - longpressMovement.pageY) > 10
            ) {
              clearTimeout(longpressTimer);
            }
          })
          // If they lift their finger immediately clear the timer
          .on("touchend.batchgeocontextmenu", function (e) {
            //prevent menu from auto closing on iphone
            if (overlayElement.hasClass("context-menu-overlay-show"))
              e.preventDefault();
            clearTimeout(longpressTimer);
          });
      },

      /**
       * destroy: removes all traces of this instance of the context menu.
       */
      destroy: function () {
        // remove the context menu elements from the DOM
        menuElement?.remove();
        overlayElement?.remove();

        // and remove the event listeners
        $(options.triggerEl).off("touchstart.batchgeocontextmenu");
        $(options.triggerEl).off("touchmove.batchgeocontextmenu");
        $(options.triggerEl).off("touchend.batchgeocontextmenu");
        $(options.triggerEl).off("mouseup.batchgeocontextmenu");
        $(document.body).off(
          "contextmenu.batchgeocontextmenu",
          this._contextMenuHandler,
        );
      },

      clickMenu: function (e) {
        if (menuStatus) {
          _privateAPI.hideMenu();
          $body.off("mousedown", this);
        } else {
          if (BatchGeoDevices.is("mobile")) {
            _privateAPI.showMobileMenu();
          } else {
            var buttonOffset = $(e.currentTarget).offset();
            _privateAPI.showMenu(buttonOffset.left, buttonOffset.top, true);
            $(e.target).addClass("active");

            // Handle body click to hide context menu
            var bodyMousedownHandler = function (event) {
              var bodyClick = event.target !== e.target;
              if (menuStatus && bodyClick) {
                _privateAPI.hideMenu();
                $body.off("mousedown", bodyMousedownHandler);
              }
            };
            $body.on("mousedown", bodyMousedownHandler);
          }
        }
      },
    };
  };
})();
